var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "repository-curricula" } },
    [
      _c(
        "div",
        {
          staticClass:
            "flex items-center justify-between gap-10 px-6 py-4 border-b bg-pure-white border-slate-400",
          attrs: { id: "curricula-header" }
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col gap-1" },
            [
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c("BlTextTitle3", { attrs: { text: "Curricula" } }),
                  _vm._v(" "),
                  _c("BlBubbleCount", {
                    attrs: { count: _vm.totalCurriculums || 0 }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("BlTextBody2", {
                attrs: {
                  text: "Create curricula to classify and manage the targets."
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.currentUser.role.includes("admin")
            ? _c("BlInputButton", {
                attrs: { icon: "plus", label: "New curriculum" },
                on: {
                  clicked: function($event) {
                    _vm.newOpened = true
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.newOpened
        ? _c("NewCurriculumModal", {
            on: {
              "close-modal": function($event) {
                _vm.newOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.currentUser.role.includes("admin")
        ? _c("div", { staticClass: "w-full px-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center gap-2 px-4 py-2 rounded-b bg-info-100"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "grid flex-shrink-0 w-10 h-10 place-items-center",
                    style: { background: "#E4F1FA", borderRadius: "0.25rem" }
                  },
                  [
                    _c("BlIcon", {
                      staticClass: "w-6 h-6",
                      attrs: { icon: "toast-info" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("BlTextBody1", {
                  staticClass: "text-info",
                  attrs: {
                    text:
                      "Please note that adding or editing the curricula is restricted to the admin role."
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "sticky z-50 flex items-center gap-2 px-6 py-4 top-18 bg-slate-100"
        },
        [
          _c("BlInputSearch", {
            staticClass: "w-80",
            attrs: { input: _vm.searchInput },
            on: { changed: _vm.onInputSearch }
          }),
          _vm._v(" "),
          _c("BlSort", {
            staticClass: "w-60",
            attrs: {
              options: _vm.sortOptions,
              defaultValue: { primary: "date", secondary: "desc" }
            },
            on: {
              change: function($event) {
                return _vm.onChangeSort($event)
              }
            },
            model: {
              value: _vm.sortInput,
              callback: function($$v) {
                _vm.sortInput = $$v
              },
              expression: "sortInput"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.pageLoading
        ? _c("div", { staticClass: "grid h-128 place-items-center" }, [
            _c("div", { staticClass: "blum-loader" })
          ])
        : !_vm.curriculums.length
        ? _c(
            "div",
            { staticClass: "flex flex-col items-center justify-center h-128" },
            [
              _c("BlTextBody1", {
                staticClass: "text-center",
                attrs: { text: "Currently, there are no curricula to display." }
              }),
              _vm._v(" "),
              _c("BlTextBody1", {
                staticClass: "text-center",
                attrs: {
                  text: "After creating a new curriculum, it will appear here."
                }
              }),
              _vm._v(" "),
              _vm.currentUser.role.includes("admin")
                ? _c("BlInputButton", {
                    staticClass: "p-0",
                    attrs: { label: "Create a new curriculum", type: "plain" },
                    on: {
                      clicked: function($event) {
                        _vm.newOpened = true
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "flex flex-col gap-6 px-6 pb-10" },
            [
              _c(
                "div",
                { staticClass: "border rounded border-slate-400" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky z-10 flex items-center flex-grow-0 w-full top-36 bg-slate-300"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 rounded-tl",
                          style: { width: "25%" }
                        },
                        [_c("BlTextSubtitle3", { attrs: { text: "Name" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4",
                          style: { width: "12.5%" }
                        },
                        [
                          _c("BlTextSubtitle3", {
                            attrs: { text: "Number of targets" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4",
                          style: { width: "50%" }
                        },
                        [
                          _c("BlTextSubtitle3", {
                            attrs: { text: "Description" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 rounded-tr",
                          style: { width: "12.5%" }
                        },
                        [_c("BlTextSubtitle3", { attrs: { text: "" } })],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.curriculums, function(curriculum) {
                    return _c(
                      "div",
                      {
                        key: curriculum.id,
                        staticClass:
                          "flex items-center flex-grow-0 w-full border-b border-slate-400 bg-pure-white"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-shrink-0 h-20 gap-2 px-4 py-3",
                            style: { width: "25%" },
                            attrs: { title: curriculum.name }
                          },
                          [
                            _c("div", {
                              staticClass:
                                "flex-shrink-0 w-4 h-4 mt-1 rounded-full",
                              style: { backgroundColor: curriculum.color }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody1", {
                              staticClass: "line-clamp-2 text-slate-1000 h-13",
                              attrs: { text: curriculum.name }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "flex-shrink-0 h-20 px-4 py-3",
                            style: { width: "12.5%" }
                          },
                          [
                            _c("BlTextBody1", {
                              staticClass: "line-clamp-2 h-13",
                              attrs: { text: curriculum.number_of_targets }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "flex-shrink-0 h-20 px-4 py-3",
                            style: { width: "50%" },
                            attrs: { title: curriculum.description }
                          },
                          [
                            _c("BlTextBody1", {
                              staticClass:
                                "whitespace-pre-line line-clamp-2 h-13",
                              attrs: { text: curriculum.description }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex justify-end flex-shrink-0 h-20 gap-2 px-4 py-3",
                            style: { width: "12.5%" }
                          },
                          [
                            _vm.currentUser.role.includes("admin")
                              ? _c("BlInputButton", {
                                  attrs: {
                                    label: "Edit",
                                    type: "outlined",
                                    dense: ""
                                  },
                                  on: {
                                    clicked: function($event) {
                                      _vm.editOpened = curriculum.id
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to:
                                        "/repository/curriculum/" +
                                        curriculum.id
                                    }
                                  },
                                  [
                                    _c("BlInputButton", {
                                      attrs: {
                                        label: "View",
                                        type: "outlined",
                                        dense: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.totalCurriculums > 25
                ? _c("BlInputPagination", {
                    attrs: {
                      page: _vm.page,
                      perPage: _vm.perPage,
                      total: _vm.totalCurriculums
                    },
                    on: {
                      changed: _vm.changePage,
                      "changed-per-page": _vm.changePerPage
                    }
                  })
                : _vm._e()
            ],
            1
          ),
      _vm._v(" "),
      _vm.editOpened
        ? _c("EditCurriculumModal", {
            attrs: {
              curriculum: _vm.curriculums.find(function(i) {
                return i.id === _vm.editOpened
              })
            },
            on: {
              "close-modal": function($event) {
                _vm.editOpened = null
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49d99d6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49d99d6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repository/Curricula.vue
// module id = null
// module chunks = 